import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from 'components/_new/Button';
import { Dialog } from 'components/_new/Dialog';
import { Spinner } from 'components/_new/Spinner';
import BusinessCard from 'components/_common/panel/BusinessCard';
import { usePair } from 'contexts/pairContext';
import { fullName } from 'utils/fullName';
import { RouterUrlParams } from '../../../App';
import { useCounterpartApplication } from '../../../contexts/useCounterpartApplication';

interface PairPartnerInfoProps {
	className?: string;
}

const PairPartnerInfo: React.FC<PairPartnerInfoProps> = ({ className = '' }) => {
	const { t } = useTranslation();
	const { organizationName, programName, type } = useParams() as RouterUrlParams;
	const {
		pair: { id: pairId, application: pairApplication },
	} = usePair();

	const [showProfileModal, setShowProfileModal] = useState(false);
	const { data: counterpartData, isLoading } = useCounterpartApplication();

	const pairFullName = fullName(pairApplication!);

	const renderDialogContent = () => {
		if (isLoading) {
			return <Spinner center />;
		}

		if (!counterpartData) {
			return <div>Failed to load counterpart application details.</div>;
		}

		return <BusinessCard data={counterpartData} />;
	};

	const handleNavigateToPairDetails = () => {
		const url = `/panel/${organizationName}/${programName}/${type}/pair/${pairId}/pair-details`;
		window.open(url, '_blank');
	};

	return (
		<>
			<Dialog
				visible={showProfileModal}
				onHide={() => setShowProfileModal(false)}
				className="p-dialog-buissnescard"
				title={t('userPanel.pairing.personalDetailsPair', {
					type: counterpartData?.applicationRole === 'mentee' ? t('misc.mentees') : t('misc.mentors'),
				})}
				size="lg"
			>
				{renderDialogContent()}
			</Dialog>

			<div className={`flex flex-row align-items-center mt-1 ${className}`}>
				<Button
					className="p-0 cursor-pointer"
					onClick={() => setShowProfileModal(true)}
					variant="primary-text"
					label={pairFullName}
				/>
				<Button
					className="ml-1 p-0 cursor-pointer"
					onClick={handleNavigateToPairDetails}
					icon="arrow-up-right-from-square"
					variant="primary-text"
					iconStyle="solid"
					label=""
					iconOnly
				/>
			</div>
		</>
	);
};

export default PairPartnerInfo;
